import React from "react";
import '../containers/pages/Common.scss';
import styles from '../containers/pages/Appliances/Appliance.module.scss';

interface Props {
   tableName:String,
   headerList:Array<string>,
   valuesList:Array<object>,
   valuesKey:Array<string>,
   cellPadding?:Array<string>,
   moduleList?:boolean,
}

interface State {

}
export default class PageTable extends React.Component<Props>{
    render() {
        const {tableName,headerList,valuesList,valuesKey, moduleList} = this.props || {};
        return (    
                <>
                        <div style={{whiteSpace:'nowrap',marginLeft:'20px'}} >{tableName}</div>
                        <div className={styles["appliances-details"]}>
                        {
                            <div className={styles["details-table-app"]}>
                                 <div className={`${styles["table-row-app"]} ${styles['headings']} ${moduleList ? styles.grid_view : ''}`}>
                                 {(headerList || []).map((heading, index)=>{
                                        return(
                                            <div className={styles["table-cell-app"]}>
                                               {heading}
                                            </div>
                                        )
                                    })}
                                </div>
                                {
                                    (valuesList || []).map((rowData)=>{
                                        return(
                                            <div className={`${styles["table-row-app"]} ${moduleList ? styles.grid_view : ''}`}>
                                                {(valuesKey || []).map(key=>{
                                                   if(rowData[key] && Array.isArray(rowData[key])){
                                                       return rowData[key]?.length?<div className={styles["table-cell-app"]}><ul>{
                                                            rowData[key].map(value=>
                                                               (value ? <li>
                                                                    {value}
                                                                </li>:null))
                                                            }</ul></div>:"NA";
                                                        }
                                                    else{
                                                        return(<div className={styles["table-cell-app"]}>
                                                            {rowData[key]? (key==='link'? <a style={{display: "block"}} href={rowData[key]}>Click Here</a> :rowData[key]):'NA'}
                                                        </div>)
                                                    }
                                                })}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>
                </>         
        )
    }

}